import { Children, type ReactNode } from "react";
import { Cluster, OverflowMenu } from "@salesapp/ui";
import { useCompactViewport } from "../../lib/useNarrowViewport";

/**
 * On a phone or tablet, keep `primary` on the row and put `more` behind a kebab.
 * Wider screens show both inline.
 */
export function ResponsiveActions({
  primary,
  more,
  className,
  moreLabel = "More actions",
}: {
  primary?: ReactNode;
  more?: ReactNode;
  className?: string;
  moreLabel?: string;
}) {
  const compact = useCompactViewport();
  const extra = Children.toArray(more);
  if (!compact || extra.length === 0) {
    return (
      <Cluster gap={2} align="center" className={className}>
        {primary}
        {more}
      </Cluster>
    );
  }
  return (
    <Cluster gap={2} align="center" className={className}>
      {primary}
      <OverflowMenu label={moreLabel}>{more}</OverflowMenu>
    </Cluster>
  );
}
